import { render, staticRenderFns } from "./PTopHero.vue?vue&type=template&id=bfee3fb2&"
import script from "./PTopHero.vue?vue&type=script&lang=js&"
export * from "./PTopHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports